/**
 * LotFeatureBanner (formerly IlBanner)
 * 
 * Displays dynamic brand promotional links or innovation banners (e.g., ExpeDRY)
 * based on lot prefix and treatment status.
 * 
 * @param {string} lot - The full lot number.
 * @param {string} tr - The treatment type (e.g., "ExpeDRY").
 */

const LotFeatureBanner = ({ lot, tr, brand }) => {
  if (!lot) return null;

  const isExpedry = tr && tr.toLowerCase() === 'expedry';
  
  // Only render if explicitly treated as ExpeDRY
  if (!isExpedry) return null;

  const prefix = lot.substring(0, 4);
  
  // Mapping of lot prefixes to partner brand URLs
  const brandLinks = {
    '1405': '//nike.com',
    '1425': '//nike.com'
  };

  const targetUrl = brandLinks[prefix] || `//alliedfeather.com/innovation/expedry?ref=tmd-com&lot=${lot}`;
  
  let bannerStyle = {}; // Initialize style object for conditional background
  // Removed explicit backgroundImage: 'none' for brand 1427 ExpeDRY, as CSS handles this for the upper-bg,
  // and il__banner should carry the visual.

  return (
    <div className="il__banner" style={bannerStyle}>
      <a href={targetUrl} target="_blank" rel="noreferrer"></a>
    </div>
  );
};

export { LotFeatureBanner };
